module.exports = __webpack_public_path__ + "fonts/Gilroy-Medium.d8ee4539.ttf";